<template>
  <v-form @submit.prevent="$emit('filtrar')" ref="formFiltro" class="filtros-acordos">
    <v-divider class="mt-2 mb-3"></v-divider>
    <v-row style="margin-top: -10px;">
      <v-col sm="6" md="4" lg="3" class="pb-0">
        <MesInput label="Período Inicial" v-model="periodoInicial" />
      </v-col>
      <v-col sm="6" md="4" lg="3" class="pb-0">
        <MesInput label="Período Final" v-model="periodoFinal" />
      </v-col>
      <v-col sm="6" md="4" lg="3" class="pb-0">
        <v-text-field label="Número do acordo" outlined dense class="input-cinza" v-model="numeroAcordo"></v-text-field>
      </v-col>
      <v-col sm="6" md="4" lg="3" class="pb-0">
        <v-text-field label="Número do acordo RD" outlined dense class="input-cinza" v-model="numeroAcordoRD"></v-text-field>
      </v-col>
    </v-row>
    <v-expansion-panels flat v-model="mostrarFiltros" accordion>
      <v-expansion-panel>
        <v-expansion-panel-content eager class="p-0 m-0">
          <v-row class="gap-vertical">
            <v-col sm="6" md="4" lg="3" class="pb-0">
              <v-text-field label="Número do contrato" outlined dense class="input-cinza" v-model="numeroContrato"></v-text-field>
            </v-col>
            <v-col sm="6" md="4" lg="3" class="pb-0">
              <v-text-field label="Número do contrato RD" outlined dense class="input-cinza" v-model="numeroContratoRD"></v-text-field>
            </v-col>
            <v-col sm="6" md="4" lg="3" class="pb-0">
              <SelectInput
                label="Bandeira"
                v-model="bandeira"
                :items="bandeiras"
                multiple
                chips
                :item-text="'text'"
                :item-value="'value'"
                :show-select-all="true"
                :menu-props="{ contentClass: 'select-outline', transition: 'slide-y-transition', zIndex: 100 }"
                clearable
                class="input-cinza"
                outlined
                dense
              />
            </v-col>
            <v-col sm="6" md="4" lg="3" class="pb-0">
              <SelectInput
                label="Fornecedor"
                v-model="fornecedor"
                :items="fornecedores"
                multiple
                chips
                :item-text="'text'"
                :item-value="'value'"
                :show-select-all="true"
                :menu-props="{ contentClass: 'select-outline', transition: 'slide-y-transition', zIndex: 100 }"
                clearable
                class="input-cinza"
                outlined
                dense
              />
            </v-col>
            <v-col sm="6" md="4" lg="3" class="pb-0">
              <SelectInput
                label="Macro Fornecedor"
                v-model="macroFornecedor"
                :items="macroFornecedores"
                multiple
                chips
                :item-text="'text'"
                :item-value="'value'"
                :show-select-all="true"
                :menu-props="{ contentClass: 'select-outline', transition: 'slide-y-transition', zIndex: 100 }"
                clearable
                class="input-cinza"
                outlined
                dense
              />
            </v-col>
            <v-col sm="6" md="4" lg="3" class="pb-0">
              <SelectInput
                label="Status"
                v-model="status"
                :items="statusList"
                multiple
                chips
                :item-text="'text'"
                :item-value="'value'"
                :show-select-all="true"
                :menu-props="{ contentClass: 'select-outline', transition: 'slide-y-transition', zIndex: 100 }"
                clearable
                class="input-cinza"
                outlined
                dense
              />
            </v-col>
            <v-col sm="6" md="4" lg="3" class="pb-0">
              <SelectInput
                label="Cluster"
                v-model="cluster"
                :items="clusters"
                multiple
                chips
                :item-text="'text'"
                :item-value="'value'"
                :show-select-all="true"
                :menu-props="{ contentClass: 'select-outline', transition: 'slide-y-transition', zIndex: 100 }"
                clearable
                class="input-cinza"
                outlined
                dense
              />
            </v-col>
            <v-col sm="6" md="4" lg="3" class="pb-0">
              <SelectInput
                label="Usuário"
                v-model="usuario"
                :items="usuarios"
                multiple
                chips
                :item-text="'text'"
                :item-value="'value'"
                :show-select-all="true"
                :menu-props="{ contentClass: 'select-outline', transition: 'slide-y-transition', zIndex: 100 }"
                clearable
                class="input-cinza"
                outlined
                dense
              />
            </v-col>
            <v-col sm="6" md="4" lg="3" class="pb-0">
              <SelectInput
                label="Visível"
                v-model="visivel"
                :items="visivelList"
                multiple
                chips
                :show-select-all="true"
                :menu-props="{ contentClass: 'select-outline', transition: 'slide-y-transition', zIndex: 100 }"
                clearable
                class="input-cinza"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-divider class="mt-0 mb-3"></v-divider>
    <v-row>
      <v-col cols="3" class="px-2 ml-auto">
        <div class="new-button d-flex align-center" text>
          <span @click="expandirFiltros" style="cursor: pointer">Personalizar Filtros</span>
          <v-btn style="background: #e6e6e6; width: 20px; height: 20px" fab icon class="ml-3" @click="expandirFiltros" x-small>
            <v-icon>{{ mostrarFiltros == 0 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-btn>
        </div>
      </v-col>
      <v-col cols="9" class="ml-auto" align="end">
        <v-btn class="ml-2 new-button" color="yellow" dark @click="$emit('limpar')">
          <v-icon left>mdi-filter-off</v-icon> Limpar Filtros
        </v-btn>
        <v-btn class="ml-5 new-button" color="primary" type="submit">
          <v-icon left>mdi-filter</v-icon> Filtrar
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import MesInput from '@/components/MesInput.vue';
export default {
  name: 'FiltroCircuito',
  components: { MesInput },
  data() {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const mesAtual = `${year}-${month}`;
    return {
      periodoInicial: mesAtual,
      periodoFinal: mesAtual,
      numeroAcordo: '',
      numeroAcordoRD: '',
      numeroContrato: '',
      numeroContratoRD: '',
      bandeira: null,
      espaco: null,
      espacoMacro: null,
      fornecedor: null,
      macroFornecedor: null,
      status: null,
      cluster: null,
      acordoRegiao: null,
      numeroLote: '',
      usuario: null,
      visivel: null,
      mostrarFiltros: null,
      bandeiras: [],
      espacos: [],
      espacosMacro: [],
      fornecedores: [],
      macroFornecedores: [],
      statusList: [],
      clusters: [],
      acordoPorRegiao: [],
      usuarios: [],
      visivelList: ['Sim', 'Não'],
      carregandoFiltros: false,
      erroFiltros: null
    }
  },
  async mounted() {
    this.carregandoFiltros = true;
    try {
      const response = await this.$http().post('/acordoCampanhaCircuito/listaCampos', {});
      const data = response.data;
      this.bandeiras = data.bandeira || [];
      this.fornecedores = data.fornecedor || [];
      this.macroFornecedores = data.macrofornecedores || data.macro_fornecedor || [];
      this.statusList = data.status || [];
      this.clusters = data.cluster || [];
      this.usuarios = data.usuarios || data.usuario || [];
      this.espacos = data.espaco || [];
      this.espacosMacro = data.espaco_macro || [];
      this.acordoPorRegiao = data.regiao || [];
    } catch (e) {
      this.erroFiltros = 'Erro ao buscar filtros: ' + (e?.message || e);
    } finally {
      this.carregandoFiltros = false;
    }
  },
  methods: {
    expandirFiltros() {
      this.mostrarFiltros = this.mostrarFiltros === 0 ? null : 0;
    },
    limpar() {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const mesAtual = `${year}-${month}`;
      this.periodoInicial = mesAtual;
      this.periodoFinal = mesAtual;
      this.numeroAcordo = '';
      this.numeroAcordoRD = '';
      this.numeroContrato = '';
      this.numeroContratoRD = '';
      this.bandeira = null;
      this.espaco = null;
      this.espacoMacro = null;
      this.fornecedor = null;
      this.macroFornecedor = null;
      this.status = null;
      this.cluster = null;
      this.acordoRegiao = null;
      this.numeroLote = '';
      this.usuario = null;
      this.visivel = null;
      // Não alterar mostrarFiltros ao limpar
      this.$emit('limpar');
    }
  }
}
</script>

<style scoped>
.input-cinza {
  background: #f5f5f5 !important;
  min-height: 40px !important;
  height: 40px !important;
  font-size: 1rem !important;
}
.v-input__slot, .v-select__slot, .v-text-field__slot {
  min-height: 40px !important;
  height: 40px !important;
  font-size: 1rem !important;
}
.filtros-acordos {
  background: white;
  border-radius: 12px;
}
.filtros-acordos .v-col.pb-0 {
  margin-bottom: 24px !important;
}
.filtros-acordos .v-divider {
  margin-top: 8px !important;
  margin-bottom: 24px !important;
}

/* Espaçamento vertical entre campos de pesquisa */
.gap-vertical {
  row-gap: 24px !important;
}

</style>
